import {z} from 'zod';

import {dateWindowRefinement, optionalIsoDate} from './catalogueUi';

// Backend contract: these maximum lengths, blank is null, last order date not before orders open.
const CATALOGUE_ID_MAX_LENGTH = 100;
const VERSION_MAX_LENGTH = 50;
const NOTE_MAX_LENGTH = 2000;

const optionalTrimmedText = (maxLength: number) =>
  z
    .string()
    .trim()
    .max(maxLength)
    .transform((value) => (value === '' ? null : value))
    .nullable();
const optionalDate = optionalIsoDate.transform((value) => (value === '' ? null : value));

export const importerPriceListSchema = z
  .object({
    catalogueId: optionalTrimmedText(CATALOGUE_ID_MAX_LENGTH),
    priceListVersion: optionalTrimmedText(VERSION_MAX_LENGTH),
    dataVersion: optionalTrimmedText(VERSION_MAX_LENGTH),
    releasedOn: optionalDate,
    ordersOpenFrom: optionalDate,
    lastOrderDate: optionalDate,
    note: optionalTrimmedText(NOTE_MAX_LENGTH),
  })
  .superRefine(dateWindowRefinement('ordersOpenFrom', 'lastOrderDate'));
export type ImporterPriceListValues = z.infer<typeof importerPriceListSchema>;

export const IMPORTER_PRICE_LIST_FIELD_NAMES = {
  catalogueId: 'importerPriceList.catalogueId',
  priceListVersion: 'importerPriceList.priceListVersion',
  dataVersion: 'importerPriceList.dataVersion',
  releasedOn: 'importerPriceList.releasedOn',
  ordersOpenFrom: 'importerPriceList.ordersOpenFrom',
  lastOrderDate: 'importerPriceList.lastOrderDate',
  note: 'importerPriceList.note',
} as const;
